import React from 'react'
import NumberInput, { FormikNumberInput } from 'particles/NumberInput'
import { useNewTranslation } from 'hooks/index'
import { BaseInputFieldProps } from '.'
import { RangeInputContainer } from './style'
import Text from 'particles/Text'
import CommentContainer from 'components/Shared/Comment'
import Label from 'particles/Label'
import IconButton from 'particles/Button/IconButton'

interface NumberInputRangeProps extends BaseInputFieldProps {
    isFormikComponent?: boolean
}

const NumberInputRange: React.FC<NumberInputRangeProps> = ({
    label,
    subtext,
    size = 'm',
    firstRangeTitle,
    firstRangeName,
    firstRangePlaceholder,
    firstRangeIdentifier,
    secondRangeTitle,
    secondRangeName,
    secondRangePlaceholder,
    secondRangeIdentifier,
    isDisabled,
    width,
    inputWidth,
    isReadOnly,
    isVertical = false,
    isRequired,
    isCommentable,
    isCommented,
    errorMessage,
    onClose,
    className,
    isFormikComponent,
    identifier,
}) => {
    const [newT] = useNewTranslation()

    const NumberInputComponent = isFormikComponent ? FormikNumberInput : NumberInput

    return (
        <RangeInputContainer className={className} isVertical={isVertical} width={width}>
            {(label || subtext) && (
                <div style={{ display: 'flex' }}>
                    <CommentContainer identifier={identifier}>
                        <Label
                            title={label ?? ''}
                            subtext={subtext}
                            isRequired={isRequired}
                            size={size}
                            isCommentable={isCommentable}
                            isCommented={isCommented}
                        />
                    </CommentContainer>
                    {onClose && !isReadOnly ? (
                        <IconButton icon="x" form="icon" size="xs" color="neutral" onClick={onClose} />
                    ) : null}
                </div>
            )}
            <div className="range-input">
                <NumberInputComponent
                    label={firstRangeTitle}
                    name={firstRangeName!}
                    placeholder={firstRangePlaceholder}
                    isDisabled={isDisabled}
                    width={inputWidth}
                    isReadOnly={isReadOnly}
                    size={size}
                    className="range-input-item"
                    identifier={firstRangeIdentifier}
                />
                <Text scale="bodyS500" className="to-block">
                    {newT('general.information.toRangeFields')}
                </Text>
                <NumberInputComponent
                    label={secondRangeTitle}
                    name={secondRangeName!}
                    placeholder={secondRangePlaceholder}
                    isDisabled={isDisabled}
                    width={inputWidth}
                    isReadOnly={isReadOnly}
                    size={size}
                    className="range-input-item"
                    identifier={secondRangeIdentifier}
                />
            </div>
            {!isDisabled && errorMessage && (
                <Text scale="caption400" color="error">
                    {errorMessage}
                </Text>
            )}
        </RangeInputContainer>
    )
}

export default NumberInputRange
